import { PureComponent, HTMLProps } from 'react';
import Layer from '~/ui/react/components/Layer';
import Partial from '~/ui/react/ui-elements/Partial';
import stateContext, { IState } from '~/ui/react/contexts/state';
import './styles';

const LS_KEY_NAME = 'cookieNoticeSeen';
const LS = localStorage;

class CookieNotice extends PureComponent<IProps, ILocalState> {

    /**
     * @type IState
     */
    public static contextType = stateContext;

    /**
     * @type IState['ui']
     */
    protected uiStore: IState['ui'];

    /**
     * @type ILocalState
     */
    public state = {
        seen: false,
    }

    public constructor(props: IProps, context: IState) {
        super(props, context);

        this.uiStore = context.ui;
        this.state.seen = !!LS.getItem(LS_KEY_NAME);
    }

    /**
     * @inheritDoc
     */
    public render() {
        const that = this;
        const { props, uiStore } = that;
        const { t } = uiStore;
        const l10nPrefix = 'cookieNotice.';

        return <Layer
            show={!that.state.seen}
            mode="popup"
            className="jc-cookie-notice"
            withDocumentClicks={false}
            noFocus
            withHistory={false}
        >
            <p>
                {t(l10nPrefix + 'textPre')}
                <Partial endpoint={props.termsEndpoint}>{t(l10nPrefix + 'linkLabel')}</Partial>
                {t(l10nPrefix + 'textPost')}
            </p>

            <button
                onClick={that.onClose}
                className="comp-button -primary -wide">
                {t(l10nPrefix + 'buttonLabel')}
            </button>
        </Layer>;
    }

    /**
     * Handles close request
     */
    protected onClose = () => {
        this.setState({seen: true}, () => LS.setItem(LS_KEY_NAME, '1'));
    }
}

interface ILocalState {
    seen: boolean
}

interface IProps extends HTMLProps<CookieNotice> {
    text: string,
    buttonLabel: string,
    termsEndpoint: string,
}

export default CookieNotice;
